import { createContext, useContext, useReducer, useEffect } from "react";

const CartContext = createContext();

const key = (i) => `${i.id}__${i.size}__${i.color}`;

const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD": {
      const exists = state.find(i => key(i) === key(action.item));
      if (exists) return state.map(i => key(i) === key(action.item) ? { ...i, qty: i.qty + 1 } : i);
      return [...state, { ...action.item, qty: 1 }];
    }
    case "REMOVE": return state.filter(i => key(i) !== key(action.item));
    case "UPDATE_QTY": return state.map(i => key(i) === key(action.item) ? { ...i, qty: action.qty } : i);
    case "CLEAR": return [];
    default: return state;
  }
};

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, [], () => {
    try { return JSON.parse(localStorage.getItem("rizzglam_cart")) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("rizzglam_cart", JSON.stringify(cart));
  }, [cart]);

  const total = cart.reduce((sum, i) => sum + i.price * i.qty, 0);
  const count = cart.reduce((sum, i) => sum + i.qty, 0);
  return <CartContext.Provider value={{ cart, dispatch, total, count }}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
